import modalRemovePeriodComponent from './modalRemovePeriod.component';
import removePeriod from './removePeriod/removePeriod';

let modalRemovePeriodModule = angular.module('vacations-absences.modalRemovePeriod', [
  removePeriod
])

.component('modalRemovePeriod', modalRemovePeriodComponent)

.name;

export default modalRemovePeriodModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/modalRemovePeriod.js